const member = {
  state: () => ({
    /** 使用者群組設定列表 */
    userGroupSettingsList: [],

    /** 使用者群組設定對話框是否顯示 */
    userGroupSettingsFormVisible: false,

    /** 使用者群組設定使用者對話框是否顯示 */
    userGroupSettingsMembersVisible: false,

    /** 使用者群組設定權限對話框是否顯示 */
    userGroupSettingsPermissionVisible: false,

    /** 使用者群組設定禁用管制項目對話框是否顯示 */
    userGroupSettingsForbiddenVisible: false,

    /** 使用者群組設定其他對話框是否顯示 */
    userGroupSettingsOtherVisible: false,

    /** 使用者設定新增對話框是否顯示 */
    userSettingsFormVisible: false,

    /** 使用者設定群組對話框是否顯示 */
    userSettingsGroupVisible: false,

    /** 使用者設定許可權對話框是否顯示 */
    userSettingsPermissionVisible: false,

    /** 使用者設定其他功能對話框是否顯示 */
    userSettingsOtherFunctionVisible: false,

    /** 通知設定列表 */
    notificationSettingList: [],

    /** 通知設定新增對話框是否顯示 */
    notificationSettingsFormVisible: false,

    /** 通知設定群組對話框是否顯示 */
    notificationSettingsGroupVisible: false,

    /** 通知設定人員管理對話框是否顯示 */
    notificationSettingsMemberVisible: false,
  }),

  mutations: {
    /** 使用者群組設定列表設值 */
    setUserGroupSettingsList(state, value) {
      state.userGroupSettingsList = value;
    },

    /** 是否顯示使用者群組設定對話框 */
    setUserGroupSettingsFormVisible(state, value) {
      state.userGroupSettingsFormVisible = value;
    },

    /** 是否顯示使用者群組設定使用者對話框 */
    setUserGroupSettingsMembersVisible(state, value) {
      state.userGroupSettingsMembersVisible = value;
    },

    /** 是否顯示使用者群組設定權限對話框 */
    setUserGroupSettingsPermissionVisible(state, value) {
      state.userGroupSettingsPermissionVisible = value;
    },

    /** 是否顯示使用者群組設定禁用管制項目對話框 */
    setUserGroupSettingsForbiddenVisible(state, value) {
      state.userGroupSettingsForbiddenVisible = value;
    },

    /** 是否顯示使用者群組設定其他對話框  */
    setUserGroupSettingsOtherVisible(state, value) {
      state.userGroupSettingsOtherVisible = value;
    },

    /** 是否顯示使用者設定新增對話框 */
    setUserSettingsFormVisible(state, value) {
      state.userSettingsFormVisible = value;
    },

    /** 是否顯示使用者設定群組對話框 */
    setUserSettingsGroupVisible(state, value) {
      state.userSettingsGroupVisible = value;
    },

    /** 是否顯示使用者設定許可權對話框 */
    setUserSettingsPermissionVisible(state, value) {
      state.userSettingsPermissionVisible = value;
    },

    /** 是否顯示使用者設定其他功能對話框 */
    setUserSettingsOtherFunctionVisible(state, value) {
      state.userSettingsOtherFunctionVisible = value;
    },

    /** 通知設定列表 設值 */
    setNotificationSettingList(state, value) {
      state.notificationSettingList = value;
    },

    /** 是否顯示通知設定新增對話框 */
    setNotificationSettingsFormVisible(state, value) {
      state.notificationSettingsFormVisible = value;
    },

    /** 是否顯示通知設定群駔對話框 */
    setNotificationSettingsGroupVisible(state, value) {
      state.notificationSettingsGroupVisible = value;
    },

    /** 是否顯示通知設定人員管理對話框 */
    setNotificationSettingsMemberVisible(state, value) {
      state.notificationSettingsMemberVisible = value;
    },
  },
};

export default member;
